import React, { memo, useState } from 'react';
import { Input, Label, InputGroup, InputGroupText } from 'reactstrap';

const TextInput = memo(({ input_type, isrequired, allowOnlyNumbers, allowDecimals, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    const handleNumberChange = (e) => {
        const val = e.target.value;

        // Only numbers
        if (!allowDecimals && /^\d*$/.test(val)) {
            props.onChange?.(e);
        }

        // Numbers + decimal (only one dot allowed)
        if (allowDecimals && /^\d*\.?\d*$/.test(val)) {
            props.onChange?.(e);
        }
    };

    return (
        <>
            {input_type == 2 ? (
                <>
                    <Label className="form-label" htmlFor={props.name}>
                        {props.label}
                        {isrequired && <i className="ri-asterisk ri-xs rq_error ms-1"></i>}
                    </Label>
                    <div className="position-relative auth-pass-inputgroup mb-3">
                        <Input
                            className="pe-5 password-input"
                            bsSize="sm"
                            id={props.name}
                            type={showPassword ? 'text' : 'password'}
                            {...props}
                        />
                        {props.value !== '' && (
                            <button
                                className="btn btn-link btn-sm position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                type="button"
                                onClick={togglePasswordVisibility}
                                tabIndex={-1}
                            >
                                <i className={`align-middle ${showPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}`}></i>
                            </button>
                        )}
                        <div className="custom-invalid-error">{props.error_msg}</div>
                    </div>
                </>
            ) : (
                <div className="mb-3">
                    {props.hasOwnProperty('label') && (
                        <Label htmlFor={props.name} className="form-label">
                            {props.label}
                            {isrequired && <i className="ri-asterisk ri-xs rq_error ms-1"></i>}
                        </Label>
                    )}
                    <InputGroup size="sm">
                        {props.prefix && <InputGroupText>{props.prefix}</InputGroupText>}
                        <Input
                            maxLength={props.maxlength || undefined}
                            type="text"
                            id={props.name}
                            {...props}
                            onChange={allowOnlyNumbers ? handleNumberChange : props.onChange}
                            disabled={props.disabled && props.disabled}
                        />
                    </InputGroup>
                    <div className="custom-invalid-error">{props.error_msg}</div>
                </div>
            )}
        </>
    );
});

export default TextInput;
